import { Component, inject, OnInit } from '@angular/core';
import {
    AppointmentsClient,
    IMyScoreShiftQuery,
    ITrendingQuery,
    TagsRequiredScoreExportQuery,
    TagsRequiredScoreQuery,
    TagsRequiredTrendingQuery,
} from '@services';
import { ScoreDashboardComponent } from '../../../../components/library/score-dashboard/score-dashboard.component';

export function tagsRequiredPalette(): Record<string, string> {
    const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();

    return {
        ['Aged (<4)']: getColor('--bs-info'),
        ['Aged (>4)']: getColor('--bs-danger'),
        ['Completed']: getColor('--bs-success'),
    };
}

@Component({
    selector: 'app-tags-required-score',
    imports: [ScoreDashboardComponent],
    templateUrl: './tags-required-score.component.html',
})
export class TagsRequiredScoreComponent implements OnInit {
    private appointmentsClient = inject(AppointmentsClient);

    palette: Record<string, string> = {};

    loadScoreData = (query: IMyScoreShiftQuery) => {
        return this.appointmentsClient.getTagsRequiredScore(new TagsRequiredScoreQuery(query));
    }

    loadTrendingData = (query: ITrendingQuery) => {
        return this.appointmentsClient.getTagsRequiredTrending(new TagsRequiredTrendingQuery(query));
    }

    exportData = (from: Date, to: Date) => {
        return this.appointmentsClient.exportTagsRequired(new TagsRequiredScoreExportQuery({ from, to }));
    }

    ngOnInit(): void {
        this.palette = tagsRequiredPalette();
    }
}
